var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 消杀日报 "),_c('bottom-tab')],1)}
var staticRenderFns = []

export { render, staticRenderFns }